import React from 'react';
import SubmissionDetails from '../../../SubmissionDetails';
import TextRenderer from '../../../TextRenderer';
import { isEditorTextEmpty } from '@wix/da-editor-tiptap/pkg/components/utils/helpers';
import MeasuredTorpedo from '../../../Torpedo/MeasuredTorpedo';
import DeviationThumbView from '../../../DeviationViews/Thumb/Standard';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import MediaService from '../../../utils/DeviationMediaService';
import DeviationAttributeCSV from '../_partials/DeviationAttributeCSV';
import CommissionViewerV3 from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Commission';
import s from './Commission.scss';
const exampleRenderer = (renderProps, item)=>{
    return /*#__PURE__*/ React.createElement(DeviationThumbView, {
        className: s['example'],
        deviation: item.dto.deviation,
        width: item.width,
        height: item.height
    });
};
export const CommissionDetails = ({ deviation, deviation: { commission: { examples = [] } = {}, textContent } })=>{
    const isEmpty = textContent && isEditorTextEmpty(textContent);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['author-block']
    }, /*#__PURE__*/ React.createElement(SubmissionDetails, {
        deviation: deviation
    })), !isEmpty && /*#__PURE__*/ React.createElement(TextRenderer, {
        className: s['description'],
        textContent: textContent,
        viewerKey: deviation.deviationId,
        tipTapViewer: CommissionViewerV3,
        cookieType: MeasuredCookieType.DEVIATION_DESCRIPTION,
        defaultSize: {
            desktop: {
                width: 780,
                height: 800
            },
            mobile: {
                width: 380,
                height: 400
            }
        },
        withSafetyCheckModal: true
    }), examples.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: s['examples']
    }, /*#__PURE__*/ React.createElement(MeasuredTorpedo, {
        container: {
            width: 780
        },
        items: examples.map((item)=>{
            const largest = MediaService.getThumbDimensions(item);
            return {
                id: `deviation-${item.deviationId}`,
                width: largest.width || 0,
                height: largest.height || 0,
                deviation: item
            };
        }),
        renderItem: exampleRenderer,
        cookieDim: "width",
        cookieType: MeasuredCookieType.BROWSE
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['misc']
    }, /*#__PURE__*/ React.createElement(DeviationAttributeCSV, {
        deviation: deviation
    })));
};
CommissionDetails.displayName = 'CommissionDetails';
export default CommissionDetails;

//# sourceMappingURL=Commission.js.map